var RoadToWater = {

  init:function () {

    // var txt1 = $('.sineCanvas');
    this.canvasInit();
  },


  canvasInit: function() {

    var water1 = $('.bg-water-1'),
        water2 = $('.bg-water-2'),
        water3 = $('.bg-water-3'),
        water4 = $('.bg-water-4'),
        water5 = $('.bg-water-5'),
        water6 = $('.bg-water-6');

    var ring1 = $('.pie1'),
        ring2 = $('.pie2'),
        ring3 = $('.pie3'),
        ring4 = $('.pie4'),
        ring5 = $('.pie5'),
        ring6 = $('.pie6'),
        ring7 = $('.pie7'),
        ring8 = $('.pie8'),
        ring9 = $('.pie9'),
        ring10 = $('.pie10'),
        ring11 = $('.pie11'),
        ring12 = $('.pie12'),
        ring13 = $('.pie13'),
        ring14 = $('.pie14'),
        ring15 = $('.pie15'),
        ring16 = $('.pie16'),
        ring17 = $('.pie17'),
        ring18 = $('.pie18'),
        ring19 = $('.pie19');

    var msg1 = $('.p-rtw-gallery_msg-1'),
        msg2 = $('.p-rtw-gallery_msg-2'),
        msg3 = $('.p-rtw-gallery_msg-3'),
        msg4 = $('.p-rtw-gallery_msg-4'),
        msg5 = $('.p-rtw-gallery_msg-5'),
        msg6 = $('.p-rtw-gallery_msg-6');

    var wave1 = $('.wave-1'),
        wave2 = $('.wave-2'),
        wave3 = $('.wave-3'),
        wave4 = $('.wave-4'),
        wave5 = $('.wave-5'),
        wave6 = $('.wave-6');

    var ringTimer = 1.1;

    var waterTL = new TimelineMax({paused:true});
    var waterTL2 = new TimelineMax({paused:true});
    var ringTL = new TimelineMax({paused:true});
    var ringTLSP = new TimelineMax({paused:true});
    var ringTL2 = new TimelineMax({paused:true});
    var ringTL2SP = new TimelineMax({paused:true});
    var msgTL = new TimelineMax({paused:true});
    var msgTL2 = new TimelineMax({paused:true});
    var msgTLSP = new TimelineMax({paused:true});
    var msgTLSP2 = new TimelineMax({paused:true});

    waterTL.to(water1,4,{ease:Power2.easeInOut, bottom:'65%'},0);
    waterTL.to(water2,4,{ease:Power2.easeInOut, bottom:'65%'},3);
    waterTL.to(water3,4,{ease:Power2.easeInOut, bottom:'65%'},8);

    waterTL2.to(water4,4,{ease:Power2.easeInOut, bottom:'65%'},0);
    waterTL2.to(water5,4,{ease:Power2.easeInOut, bottom:'65%'},4);
    waterTL2.to(water6,4,{ease:Power2.easeInOut, bottom:'65%'},6);

    ringTL.to(ring1,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*0);
    ringTL.to(ring2,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*1);
    ringTL.to(ring3,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*2);
    ringTL.to(ring4,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*3);
    ringTL.to(ring5,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*4);
    ringTL.to(ring6,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*5);
    ringTL.to(ring7,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*6);
    ringTL.to(ring8,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*7);
    ringTL.to(ring9,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*8);

    ringTLSP.to(ring1,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*0);
    ringTLSP.to(ring2,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*1);
    ringTLSP.to(ring4,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*2);
    ringTLSP.to(ring3,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*3);
    ringTLSP.to(ring6,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*4);
    ringTLSP.to(ring5,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*5);
    ringTLSP.to(ring7,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*6);
    ringTLSP.to(ring8,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*7);
    // ringTLSP.to(ring9,3,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*8);

    ringTL2.to(ring11,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*0);
    ringTL2.to(ring10,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*1);
    ringTL2.to(ring19,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*1);
    ringTL2.to(ring12,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*2);
    ringTL2.to(ring13,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*3);
    ringTL2.to(ring14,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*4);
    ringTL2.to(ring15,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*5);
    ringTL2.to(ring18,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*6);
    ringTL2.to(ring17,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*7);
    ringTL2.to(ring16,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*8);
    ringTL2.to(ring19,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*9);

    ringTL2SP.to(ring19,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*0);
    ringTL2SP.to(ring10,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*1);
    ringTL2SP.to(ring12,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*2);
    ringTL2SP.to(ring11,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*3);
    ringTL2SP.to(ring15,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*4);
    ringTL2SP.to(ring13,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*5);
    ringTL2SP.to(ring16,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*6);
    ringTL2SP.to(ring14,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*7);
    ringTL2SP.to(ring18,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*8);
    ringTL2SP.to(ring17,1,{ease:Power2.easeInOut, strokeDasharray:'100,0,0,0'},ringTimer*9);

    msgTL.to(wave1,1,{ease:Power2.easeInOut, opacity:0},3);
    msgTL.to(msg1,1,{ease:Power2.easeInOut, opacity:1},3);
    msgTL.to(wave2,1,{ease:Power2.easeInOut, opacity:0},6);
    msgTL.to(msg2,1,{ease:Power2.easeInOut, opacity:1},6);
    msgTL.to(wave3,1,{ease:Power2.easeInOut, opacity:0},11);
    msgTL.to(msg3,1,{ease:Power2.easeInOut, opacity:1},11);

    msgTLSP.to(msg1,1,{ease:Power2.easeInOut, opacity:1},1);
    msgTLSP.to(msg2,1,{ease:Power2.easeInOut, opacity:1},2);
    msgTLSP.to(msg3,1,{ease:Power2.easeInOut, opacity:1},3);

    msgTL2.to(wave4,1,{ease:Power2.easeInOut, opacity:0},3);
    msgTL2.to(msg4,1,{ease:Power2.easeInOut, opacity:1},3);
    msgTL2.to(wave5,1,{ease:Power2.easeInOut, opacity:0},7);
    msgTL2.to(msg5,1,{ease:Power2.easeInOut, opacity:1},7);
    msgTL2.to(wave6,1,{ease:Power2.easeInOut, opacity:0},9);
    msgTL2.to(msg6,1,{ease:Power2.easeInOut, opacity:1},9);

    msgTLSP2.to(msg4,1,{ease:Power2.easeInOut, opacity:1},1);
    msgTLSP2.to(msg5,1,{ease:Power2.easeInOut, opacity:1},2);
    msgTLSP2.to(msg6,1,{ease:Power2.easeInOut, opacity:1},3);

    var tlFlag = false;

    $(window).scroll(function () {
      var $top = $(window).scrollTop();

      if($top >250){
        $('.upper-stream').addClass('svgDraw');
        topWaterTL();
        tlFlag = true;
      }
    });

    function topWaterTL() {
      var w = $(window).width();

      if(w<768){
        // ringTLSP.play();

        msgTLSP.play();
      }else{
        ringTL.play();
        msgTL.play();
      }

      waterTL.play();
    }


    //MODAL
    $('[data-type="modalOpen"]').click(function(){

      modalShow();
      var yId = $(this).attr('data-youtube');
      var gId = $(this).attr('data-photo');

      if(yId){
        playMov(yId);
      }else if(gId){
        imgZoom(gId);
      }
    });

    //MODAL OVERLAY
    $('.p-rtw-overlay').click(function(){
      modalHide();
    });

    function playMov(id){
      $('.p-rtw-modal .p-rtw-modal_img,.p-rtw-frame').hide();
      $('iframe').show();
      var a = $('.p-rtw-modal').find('iframe').attr('src','https://www.youtube.com/embed/'+id+'?showinfo=0');
    }
    function imgZoom(id){
      $('iframe').hide();
      $('.p-rtw-modal').find('img').show();
      var a = $('.p-rtw-modal .p-rtw-modal_img').attr('src','/assets/img/road-to-water/gallery/'+id+'.png');
    }
    function modalShow(){
      $('.p-rtw-overlay,.p-rtw-modal').css({'display':'block'});
      $('.p-rtw-overlay').css({'zIndex':'140'});
      $('.p-rtw-modal').css({'zIndex':'150'});
    }
    function modalHide(){
      $('.p-rtw-overlay,.p-rtw-modal').css({'display':'none'});
      $('.p-rtw-overlay').css({'zIndex':'60'});
      $('.p-rtw-modal').css({'zIndex':'70'});
      $('iframe').attr('src','');
      $('.p-rtw-modal .p-rtw-modal_img').attr('src','');
    }



    //HIDDEN GALLERY
    var streamFlag = false;

    $('[data-type="galleryOpen"]').on('click', function(){

      // $('.p-rtw-gallery-hidden').css('display','block');
      $('.p-rtw-gallery-hidden').slideToggle();
      $('[data-type="galleryOpen"]').css('display','none');
      TweenMax.to($('.p-rtw-stream-bot'),1.5,{ease:Power2.easeInOut, opacity:1});
      if(!streamFlag) {
        $('.lower-stream').addClass('svgDraw');
        botWaterTL();
        streamFlag = true;
      }

    })

    function botWaterTL() {
      var w = $(window).width();

      if(w<768){
        // ringTL2SP.play();
        msgTLSP2.play();
      }else{
        ringTL2.play();
        msgTL2.play();
      }

      waterTL2.play();
    }

    $('[data-type="galleryClose"]').on('click', function(){

      // $('.p-rtw-gallery-hidden').css('display','none');
      $('.p-rtw-gallery-hidden').slideToggle();
      $('[data-type="galleryOpen"]').css('display','block');
      TweenMax.to($('.p-rtw-stream-bot'),0.1,{ease:Power2.easeInOut, opacity:0});

    })

    var mvSection = $('.p-rtw-mv');
    var windowH = $(window).height();
    var modalW = $('.p-rtw-modal').width();
    var modalRatio = .5622;

    $('.p-rtw-mv').css({'height':(windowH-120)+'px'});
    $('.p-rtw-modal').css({'height':(modalW*modalRatio)+'px'});
    $('.p-rtw-slide_bg_img').css({'height':(windowH)+'px'});
    $('iframe').css({'height':(modalW*modalRatio)+'px','width':(modalW)+'px'});

    //MV SLIDE SP
    $('.p-rtw-slide').slick({
      infinite: true,
      slideToShow: 1,
      speed: 1500,
      adaptiveHeight: true,
      autoplay: true,
      arrows: false,
      dots: false,
      fade: true,
    });
    $('.p-rtw-slide_bg').slick({
      infinite: true,
      slideToShow: 1,
      speed: 1500,
      adaptiveHeight: true,
      autoplay: true,
      arrows: false,
      dots: false,
      fade: true,
    });

    function movAppend(){
      $('.p-rtw-mv').append("<video playsinline autoplay muted loop src='/assets/video/road-to-water/road_to_water.mp4' class='p-rtw-vid'></video><video playsinline autoplay muted loop src='/assets/video/road-to-water/road_to_water.mp4' class='p-rtw-bgvid'></video>");
    }

    var movFlag = false;

    $(window).resize(function() {
      var w = $(window).width();
      // var h = $(window).height();

      if(w<768){

      }else{
        if(!movFlag){
          movAppend();
          movFlag = true;
        }
      }

      // $('.p-rtw-mv').css({'height':(h-120)+'px'});
    });

    $(window).on('load',function() {
      var w = $(window).width();

      if(w<768){

      }else{
        if(!movFlag){
          movAppend();
          movFlag = true;
        }
      }
    });

  },

};



module.exports = RoadToWater;



//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_roadToWater.js
// module id = 19
// module chunks = 0